export default "__VITE_ASSET__CHkUgfxm__"